(function () {
  var ALL_COLORS = ['green', 'white', 'cream', 'black', 'orange', 'blue', 'pink', 'yellow', 'brown', 'beige', 'red'];
  var currentColor = null;
  var debounceTimer = null;
  var isApplying = false;
  var patched = false;

  function getSelectedColor() {
    var checked = document.querySelector('input[type="radio"][name*="[Color]"]:checked');
    return checked ? checked.value.toLowerCase() : null;
  }

  function getSlideColor(slide) {
    var img = slide.querySelector('img');
    if (!img) return null;
    var alt = (img.getAttribute('alt') || '').toLowerCase();
    for (var i = 0; i < ALL_COLORS.length; i++) {
      if (alt.includes(ALL_COLORS[i])) return ALL_COLORS[i];
    }
    return null;
  }

  function isSlideVisible(slide) {
    var c = getSlideColor(slide);
    return !c || c === currentColor;
  }

  function applyFilter(color) {
    if (isApplying) return;
    isApplying = true;

    document.querySelectorAll('li.product-thumbnail-list-item').forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      var matchedColor = null;
      for (var i = 0; i < ALL_COLORS.length; i++) {
        if (alt.includes(ALL_COLORS[i])) { matchedColor = ALL_COLORS[i]; break; }
      }
      if (matchedColor && matchedColor !== color) {
        item.style.setProperty('display', 'none', 'important');
      } else {
        item.style.removeProperty('display');
      }
    });

    isApplying = false;
  }

  function getVisibleSlides() {
    return Array.from(document.querySelectorAll('.splide--product .splide__list > .splide__slide')).filter(isSlideVisible);
  }

  function getCurrentVisibleIndex() {
    var splideEl = document.querySelector('.splide--product');
    if (!splideEl) return 0;
    var activeSlide = splideEl.querySelector('.splide__slide.is-active');
    if (!activeSlide) return 0;
    return getVisibleSlides().indexOf(activeSlide);
  }

  function goToVisibleSlide(visibleIndex) {
    var visible = getVisibleSlides();
    var target = visible[visibleIndex];
    if (!target) return;
    var mediaId = target.querySelector('[data-media-id]') ? target.querySelector('[data-media-id]').getAttribute('data-media-id') : null;
    if (!mediaId) {
      // Try getting media id from the slide itself
      var allSlides = Array.from(document.querySelectorAll('.splide--product .splide__list > .splide__slide'));
      var realIndex = allSlides.indexOf(target);
      // Click corresponding thumbnail
      var thumbs = Array.from(document.querySelectorAll('li.product-thumbnail-list-item'));
      var visibleThumbs = thumbs.filter(function(t) { return t.style.display !== 'none'; });
      if (visibleThumbs[visibleIndex]) {
        var btn = visibleThumbs[visibleIndex].querySelector('a, button');
        if (btn) btn.click();
      }
      return;
    }
    // Click the matching thumbnail
    var thumb = document.querySelector('li.product-thumbnail-list-item[data-media-id="' + mediaId + '"] a, li.product-thumbnail-list-item[data-media-id="' + mediaId + '"] button');
    if (thumb) thumb.click();
  }

  function patch() {
    if (patched) return;

    var splideEl = document.querySelector('.splide--product');
    if (!splideEl) return;

    // Disable swipe natively via Aura's own attribute
    splideEl.setAttribute('data-drag-disabled', 'true');

    var prevBtn = splideEl.querySelector('.splide__arrow--prev');
    var nextBtn = splideEl.querySelector('.splide__arrow--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var idx = getCurrentVisibleIndex();
        if (idx > 0) goToVisibleSlide(idx - 1);
      }, { capture: true });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var idx = getCurrentVisibleIndex();
        goToVisibleSlide(idx + 1);
      }, { capture: true });
    }

    patched = true;
  }

  function filterMedia(colorValue) {
    if (!colorValue) return;
    currentColor = colorValue.toLowerCase();
    applyFilter(currentColor);
    setTimeout(function() { applyFilter(currentColor); }, 150);
    setTimeout(function() { applyFilter(currentColor); }, 400);
    setTimeout(function() { applyFilter(currentColor); }, 800);
  }

  new MutationObserver(function() {
    if (!currentColor || isApplying) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      applyFilter(currentColor);
    }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  function init() {
    var initial = getSelectedColor();
    if (initial) filterMedia(initial);

    setTimeout(patch, 500);
    setTimeout(patch, 1000);
    setTimeout(patch, 2000);

    document.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"][name*="[Color]"]')) {
        filterMedia(e.target.value);
      }
    });

    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        filterMedia(e.detail.variant.option1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();